import { DashboardAdmin } from '../../components/Dashboard';

export function Dashboard() {
  return <DashboardAdmin />;
}
